var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "20px 0 0 0", "background-color": "#2D2D2D" } },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("span", { staticClass: "similar-properties-style" }, [
              _vm._v("Properties in similar areas")
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-carousel",
            { attrs: { type: "card" } },
            _vm._l(3, function(item) {
              return _c(
                "el-carousel-item",
                { key: item },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticStyle: {
                                    border: "0 none",
                                    "border-radius": "initial"
                                  },
                                  attrs: {
                                    "body-style": { padding: "0px" },
                                    shadow: "never"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "image",
                                    staticStyle: {
                                      "margin-bottom": "20px",
                                      height: "135px",
                                      width: "100%"
                                    },
                                    attrs: {
                                      src: require("../../assets/similar-search-1.jpg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "10px" },
                                      attrs: { span: 24 }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "20px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "price-style" },
                                            [_vm._v("$650,000 - $670,000")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "address-style" },
                                            [_vm._v("3 Park Terrace, Enfield")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("el-row", [
                                        _c(
                                          "span",
                                          { staticClass: "state-style" },
                                          [_vm._v("South Australia 5085")]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a130532", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a130532","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/similarProperties.vue
// module id = null
// module chunks = 